<template>
  <div
    v-loading="true"
    class="logout-view"
    :element-loading-text="loadingText"
    element-loading-background="rgba(0, 0, 0, 0.1)" />
</template>

<script>

const LOGOUT_STRING = '[LOGOUT]';
const LOGOUT_FLAG = 'logout_flag';

export default {
  name: 'ClaveUnicaView',
  props: {
    action: {
      type: String,
      default: 'logout'
    }
  },
  computed: {
    loadingText() {
      return this.action === 'logout' ? 'Cerrando sesión...' : 'Iniciando sesión...';
    }
  },
  mounted() {
    if (this.action === 'logout') {
      window.localStorage.setItem(LOGOUT_FLAG, LOGOUT_STRING);
      this.$nextTick(() => {
        this.$store.dispatch('logout');
      });
    } else {
      let token = this.getCookie('adonis-token');
      window.localStorage.removeItem(LOGOUT_FLAG);
      this.$store.dispatch('restoreUserSessionFromToken', token)
        .then(() => {
          this.$store.dispatch('claveUnicaLogout');
        });
    }
  },
  methods: {
    getCookie(cname) {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(';');
      for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }
  }
};
</script>

<style lang="scss">
  .logout-view {
    min-height: 100vh;
    min-width: 100vw;
  }
</style>
